import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LinkButton from 'flarum/common/components/LinkButton';
import BadgeUserList from './BadgeUserList';
import app from 'flarum/forum/app';
export default class BadgeItemPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--index';
    const found = app.store.getById('badges', m.route.param('id'));
    this.loading = !found;
    if (!found) {
      // Load badge categories
      app.store.find(`badges/${m.route.param('id')}`).then(badge => {
        this.loading = false;
        app.history.push('badgeItemPage', badge.name());
        this.setTitle(badge);
        m.redraw();
      });
    } else {
      app.history.push('badgeItemPage', found.name());
      this.setTitle(found);
    }
  }
  setTitle(badge) {
    app.setTitle(`${badge.name()} - ${app.translator.trans('v17development-flarum-badges.forum.badge.badges')}`);
  }
  hero() {
    return m("header", {
      className: "Hero BadgesHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, m("i", {
      "aria-hidden": "true",
      className: "icon fas fa-user-tag"
    }), " ", app.translator.trans('v17development-flarum-badges.forum.badge.badges')))));
  }
  view() {
    const badge = app.store.getById('badges', m.route.param('id'));
    return m(PageStructure, {
      className: "IndexPage BadgeItemPage",
      hero: this.hero.bind(this),
      sidebar: () => m(IndexSidebar, null)
    }, m(LinkButton, {
      href: app.route('badges'),
      icon: "fas fa-chevron-left",
      className: "Button BadgesOverviewButton"
    }, app.translator.trans('v17development-flarum-badges.forum.badge.badges')), this.loading && m(LoadingIndicator, {
      size: "large"
    }), !this.loading && badge && m("div", {
      className: "BadgeUserListInfo"
    }, badge.image() ? m("img", {
      src: badge.image(),
      className: "UserBadgeImage BadgeUserListInfo-image",
      alt: badge.name()
    }) : m("i", {
      className: badge.icon()
    }), m("div", {
      className: "BadgeUserListInfo-meta"
    }, m("h3", null, badge.name()), m("p", null, badge.description()))), badge && m("h3", null, app.translator.trans('v17development-flarum-badges.forum.badge.earned_by_count', {
      count: badge.earnedAmount()
    })), !this.loading && badge && app.forum.attribute('canViewDetailedBadgeUsers') && m(BadgeUserList, {
      state: app.userBadgeListState,
      badgeId: badge.id()
    }));
  }
}
flarum.reg.add('itqan-user-badges', 'forum/components/BadgeItemPage', BadgeItemPage);